// Module
var code = "<button type=button class=undoVertexPolygonButton> <i class=\"fas fa-undo\"></i> </button>";
// Exports
module.exports = code;